import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AdrSaveSuccessModalV3 extends Component {
  state = {
    selectedCloseType: "closeAdr", // Or "copy"
  };

  handleChange_closeType = (e) => this.setState({ selectedCloseType: e.target.name });

  getTitle = () =>
    this.props.saveType === "saveSubmit" ? "Submit Successful" : "Save Successful";

  handleClick_ok = (e) => {
    e.preventDefault();
    const { selectedCloseType } = this.state;
    this.props.handleAlert_saveSuccess(selectedCloseType);
  };

  render() {
    const { selectedCloseType } = this.state;
    const { showAlert_saveSuccess, className, saveType } = this.props;
    return (
      <Modal
        isOpen={showAlert_saveSuccess}
        toggle={() => {}}
        className={className}
        fade={false}
        size={"md"}
      >
        <ModalHeader className="bg-success text-white">
          <FontAwesomeIcon icon="check" className="mr-2" />
          {this.getTitle()}
        </ModalHeader>
        <ModalBody>
          <form id="adrSaveSuccessForm" onSubmit={this.handleClick_ok} autoComplete="off">
            <div className="card">
              <div className="card-body">
                <p>
                  This daily report has been successfully{" "}
                  {`${saveType === "saveSubmit" ? "submitted" : "saved"}`}. What would you
                  like to do?
                </p>
                <div className="form-row">
                  <div className="col">
                    <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                      <div className="radio">
                        <input
                          type="radio"
                          name="closeAdr"
                          id="closeAdr"
                          checked={selectedCloseType === "closeAdr"}
                          onChange={this.handleChange_closeType}
                          className="custom-control-input"
                        />
                        <label
                          htmlFor="closeAdr"
                          className="custom-control-label my-auto"
                        >
                          Close this daily report
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col">
                    <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                      <div className="radio">
                        <input
                          type="radio"
                          name="copyAdr"
                          id="copyAdr"
                          checked={selectedCloseType === "copyAdr"}
                          onChange={this.handleChange_closeType}
                          className="custom-control-input"
                        />
                        <label htmlFor="copyAdr" className="custom-control-label my-auto">
                          Copy this daily report, and create new
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {saveType === "saveDraft" && (
                  <div className="form-row">
                    <div className="col">
                      <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                        <div className="radio">
                          <input
                            type="radio"
                            name="keepEditing"
                            id="keepEditing"
                            checked={selectedCloseType === "keepEditing"}
                            onChange={this.handleChange_closeType}
                            className="custom-control-input"
                            disabled={saveType === "submit"}
                          />
                          <label
                            htmlFor="keepEditing"
                            className="custom-control-label my-auto"
                          >
                            Keep editing
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group mb-0">
            <input
              className="btn btn-primary mr-2"
              name="closeAdrSaveSuccessModal"
              type="submit"
              form="adrSaveSuccessForm"
              onClick={this.handleClick_ok}
              value="OK"
            />
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AdrSaveSuccessModalV3;
